var map = {
	"./Top1.svg": "12f2",
	"./Top2.svg": "9a9a",
	"./Top3.svg": "1c2c",
	"./add-cart.svg": "dbcd",
	"./address.svg": "e8fc",
	"./after-sale.svg": "24c7",
	"./cart.svg": "daca",
	"./category.svg": "d0ab",
	"./certificate.svg": "3f13",
	"./clock.svg": "755b",
	"./completed.svg": "2bae",
	"./countdown.svg": "113e",
	"./coupon.svg": "7a64",
	"./down-solid.svg": "6065",
	"./down.svg": "d8aa",
	"./feedback.svg": "eaaf",
	"./filter.svg": "2376",
	"./fire.svg": "62e5",
	"./home-hot.svg": "bd47",
	"./home.svg": "ac9d",
	"./hot-buy.svg": "e1fa",
	"./hot-sale-title.svg": "94a0",
	"./location.svg": "d2eb",
	"./my.svg": "ebd7",
	"./pay-error.svg": "7151",
	"./pay-success.svg": "4d0b",
	"./price.svg": "2eda",
	"./search.svg": "d103",
	"./service.svg": "df0e",
	"./setting.svg": "5de8",
	"./shell.svg": "fe54",
	"./shell2.svg": "c80c",
	"./shop-cart.svg": "0f16",
	"./up-down.svg": "cb06",
	"./up.svg": "5c5b",
	"./wait-pay.svg": "c6e5",
	"./wait-sent.svg": "95a7",
	"./wait-use.svg": "f254",
	"./wechat.svg": "95d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";